import React from 'react';
import { FileIcon } from '../../../../components/icons';
import { getDocumentNameAndExtension } from '../../settings/ProfileDocuments';
import { useFormikContext, FieldArray } from 'formik';
import { DocumentUploader } from '../../../../components/DocumentUploader';
import Button from '../../../../components/button/Button';

const InvestmentDocumentUploads = ({isLoading}:{isLoading:boolean}) => {
    const { values, setFieldValue } = useFormikContext<any>();

    const allUploaded = values.documents.every((doc: any) => !!doc.url);

    return (
        <div className='space-y-4 max-w-lg'>
            <h2 className='text-lg font-medium'>
                Provide the following assets and documents
            </h2>

            <FieldArray
                name='documents'
                render={() => (
                    <div className='w-full space-y-4'>
                        {values?.documents?.map(
                            (document: any, index: number) =>
                                document.url ? (
                                    <div key={document.value}>
                                        <p className='text-deepMidnightBlue text-[14px] py-2 font-[500]'>
                                            {document.label}
                                        </p>

                                        <div className='min-h-[72px] p-3 flex items-center justify-between border border-primary500 bg-aliceBlue rounded-xl'>
                                            <div className='flex w-full gap-2 items-center justify-between pr-2'>
                                                <div className='flex items-center'>
                                                    <FileIcon />
                                                    <div className='pl-4 col-span-9'>
                                                        <p className='text-[#344054] text-[14px] font-[500]'>
                                                            {
                                                                getDocumentNameAndExtension(
                                                                    document?.url
                                                                )?.name
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <DocumentUploader
                                        useAuthorization
                                        key={document.value}
                                        title={`Upload ${document.label}`}
                                        runAfterUpload
                                        accept='image/png,image/jpg,image/jpeg,application/pdf'
                                        acceptText='PNG, JPG or PDF (max. 800x400px)'
                                        documentItemId={1}
                                        uploaded={!!document.url}
                                        documentUrl={document.url || ''}
                                        status={2}
                                        onUpload={(url: string) => {
                                            setFieldValue(
                                                `documents[${index}].url`,
                                                url
                                            );
                                            setFieldValue(
                                                `documents[${index}].type`,
                                                document.value
                                            );
                                        }}
                                    />
                                )
                        )}
                    </div>
                )}
            />

            <div className='pt-4 w-full'>
                <Button
                    text='Save and Continue'
                    className='w-full'
                    type='submit'
                    disabled={!allUploaded}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};

export default InvestmentDocumentUploads;
